import FlaggedMessagesList from "../models/FlaggedMessagesList";

const FlaggedMessagesStore = FlaggedMessagesList.create({
  flaggedMessages: []
});

export default FlaggedMessagesStore;
